import {
    EntityState,
    EntityStore,
    StoreConfig,
    arrayAdd,
    arrayUpdate,
} from "@datorama/akita";
import { injectable } from "tsyringe";

import { ProductStatuses } from "../constants/ProductStatuses";
import UnavailableProductEntity from "../entities/UnavailableProductEntity";

const IN_QUEUE_STATUS = "IN_QUEUE";

type StatusItemKey = {
    productId: number;
    token: string;
    status: ProductStatuses;
};

export interface UnavailableProductsState
    extends EntityState<UnavailableProductEntity, number> {
    productStatuses: StatusItemKey[];
}

export function createInitialState(): UnavailableProductsState {
    return {
        productStatuses: [],
    };
}

@injectable()
@StoreConfig({ name: "UnavailableProductsStore" })
export class UnavailableProductsStore extends EntityStore<UnavailableProductsState> {
    constructor() {
        super(createInitialState());
    }

    public addProductInQueue(productId: number, token: string) {
        this.update(({ productStatuses }) => {
            if (
                !productStatuses.some(
                    (statusItem) => statusItem.productId === productId
                )
            ) {
                return {
                    productStatuses: arrayAdd(productStatuses, {
                        productId,
                        token,
                        status: IN_QUEUE_STATUS,
                    }),
                };
            }
        });
    }

    public setLoadingStatus(productId: number) {
        this.update(({ productStatuses }) => ({
            productStatuses: arrayUpdate(
                productStatuses,
                ({ productId: _productId }) => _productId === productId,
                { status: ProductStatuses.LOADING } as StatusItemKey
            ),
        }));
    }

    public setReadyStatus(productId: number) {
        this.update(({ productStatuses }) => ({
            productStatuses: arrayUpdate(
                productStatuses,
                ({ productId: _productId }) => _productId === productId,
                { status: ProductStatuses.READY } as StatusItemKey
            ),
        }));
    }
}
